import * as React from 'react';
import {faAngleDown, faAngleUp} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {useState} from 'react';

import Button from '../../ui/Buttons/Button';
import {AdditionalSpecValue, Item, TechSpecValue} from '../item.class';
import {PageHeader} from '../../ui/PageHeader/PageHeader';

interface TechSpecsProps {
    item: Item;
    quickView?: boolean;
}

interface TechSpecRow {
    left: TechSpecValue;
    right?: TechSpecValue;
}

export const TechSpecs = ({item, quickView}: TechSpecsProps) => {
    const [showMore, setShowMore] = useState(false);

    /**
     * TBD
     * @param additionalSpecs
     */
    const convertAdditional = (additionalSpecs: AdditionalSpecValue[]): TechSpecValue[] => {
        return additionalSpecs.map((spec) => {
            return {facetName: spec.name, facetValue: spec.value};
        });
    };

    /**
     * TBD
     * @param techSpecs
     */
    const outputTable = (techSpecs: TechSpecValue[]) => {
        const techSpecLength = techSpecs.length;
        const techSpecRows: TechSpecRow[] = [];
        let offset = techSpecLength / 2;

        // TBD
        const parity = techSpecLength % 2 === 1;
        if (parity) {
            offset += 0.5;
        }
        for (let i = 0; parity ? i < offset : i < offset; i++) {
            techSpecRows.push({left: techSpecs[i], right: techSpecs[i + offset]});
        }

        /**
         * Template
         */
        return (
            <div>
                {quickView ? (
                    <div>
                        {techSpecs.sort().map((spec) => (
                            <div
                                className="tw-border-b py-2 tw-grid tw-grid-cols-1"
                                key={spec.facetName}
                            >
                                <div className="tw-font-extrabold">{spec.facetName}</div>
                                <div>{spec.facetValue}</div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <>
                        <div className="tw-block md:tw-hidden">
                            {techSpecs.sort().map((spec) => (
                                <div
                                    className="tw-border-b py-2 tw-grid tw-grid-cols-1"
                                    key={spec.facetName}
                                >
                                    <div className="tw-font-extrabold">{spec.facetName}</div>
                                    <div>{spec.facetValue}</div>
                                </div>
                            ))}
                        </div>
                        <div className="tw-hidden md:tw-block">
                            {techSpecRows.map((tsRow, index) => (
                                <div
                                    className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4"
                                    key={index}
                                >
                                    <div className="tw-border-b py-2 tw-grid tw-grid-cols-2">
                                        <div className="tw-font-extrabold">{tsRow.left.facetName}</div>
                                        <div>{tsRow.left.facetValue}</div>
                                    </div>
                                    {tsRow.right && (
                                        <div className="tw-border-b py-2 tw-grid tw-grid-cols-2">
                                            <div className="tw-font-extrabold">{tsRow.right.facetName}</div>
                                            <div>{tsRow.right.facetValue}</div>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </>
                )}
            </div>
        );
    };

    /**
     * Template
     */
    return (
        <div
            className="tw-mb-8"
            data-e2e="TechnicalSpecificationText"
        >
            {!quickView ? (
                <>
                    <PageHeader
                        title="Technical Specifications"
                        type="h4"
                    />
                    {item.additionalSpecs?.length > 0 && (
                        <h5
                            className="tw-mt-2"
                            data-e2e="keySpecificationText"
                        >
                            Key Specifications
                        </h5>
                    )}
                </>
            ) : (
                <>
                    {item.additionalSpecs?.length > 0 && (
                        <div
                            className="tw-mt-2 tw-font-extrabold"
                            data-e2e="keySpecificationText"
                        >
                            Key Specifications
                        </div>
                    )}
                </>
            )}
            <div
                className={`${quickView ? 'tw-bg-white tw-py-3' : 'tw-bg-gray-100 tw-p-3'}`}
                data-e2e="keySpecificationsDetails"
            >
                {outputTable(item.techSpecs)}
            </div>
            {item.additionalSpecs?.length > 0 && (
                <>
                    <div className={`tw-mt-3 ${quickView ? '' : 'tw-block md:tw-hidden'}`}>
                        <Button
                            variant="outline-secondary"
                            className="tw-w-full"
                            onClick={() => {
                                setShowMore(!showMore);
                            }}
                            size="sm"
                        >
                            See {showMore ? 'Less' : 'More'} Technical Specifications{' '}
                            <FontAwesomeIcon
                                icon={showMore ? faAngleUp : faAngleDown}
                                suppressHydrationWarning
                            />
                        </Button>
                    </div>
                    <div className={`${showMore ? 'tw-block' : 'tw-hidden '}${!quickView ? ' md:tw-block' : ''}`}>
                        {quickView ? <div className="tw-mt-3 tw-font-extrabold">General</div> : <h5 className="tw-mt-3">General</h5>}
                        <div className={`${quickView ? 'tw-bg-white' : 'tw-bg-gray-100 tw-p-3'}`}>
                            {outputTable(convertAdditional(item.additionalSpecs))}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};
